import React, { useContext } from 'react'
import { DashboardContext } from 'components/DashboardContext'
import { StyledSearchInput } from 'style/styled'

const MainPageSearch = ({ userDevice = 'desktop' }) => {
	const { setSearchInput } = useContext(DashboardContext)

	return(
		<StyledSearchInput userDevice={userDevice} onSearch={setSearchInput} />
	)
}

export default MainPageSearch
